module.exports = __webpack_public_path__ + "img/tm.42b1a2fd.svg";